import { FC } from 'react';

import { Box, FormHelperText, Spacer, Text } from '@bonusly/design-system';

import { Reveal } from '../display/reveal';
import { FormErrorMessage } from './form-error-message';

type CountHelpTextProps = {
	children?: React.ReactNode;
	error?: string;
	count: number;
	max: number;
};

export const CountHelpText: FC<CountHelpTextProps> = ({ children, count, error, max }) => {
	return (
		<FormHelperText display="flex" columnGap={2} mt={1}>
			<Box>
				<Reveal if={!!error}>
					<FormErrorMessage mb={1}>{error}</FormErrorMessage>
				</Reveal>

				{children}
			</Box>
			<Spacer />
			<Text as="span" fontSize={50} color={count > max ? 'error.text' : undefined}>
				{count}/{max}
			</Text>
		</FormHelperText>
	);
};
